import { MeteringPointListResponse } from './types/meteringPoints';
import { doRequest } from './util';

/* global window, console */

const METERING_POINT_MAP: Record<string, string> = {
  id: 'id',
  uid: 'uid',
  metering_point_number: 'metering_point', // Note the name change
  customer_group: 'customer_group',
  delivery_start: 'delivery_start',
  delivery_end: 'delivery_end',
  load_profile_type: 'type',
  quantity: 'quantity',
  quantity_override: 'quantity_override',
  portfolio_id: 'portfolio_id',
  description: 'description',
  invoice_date: 'last_invoice_date',
  last_change: 'last_change',
  status: 'status',
  delivery_type: 'delivery_type',
  quantity_entrydate: 'quantity_entrydate',
  last_update: 'last_update',
  grid_area: 'grid_area',
  grid_level: 'grid_level',
  kwp: 'kwp',
  tariff: 'tariff',
  device_type: 'device_type',
  post_code: 'post_code',
  orientation: 'orientation',
  market_area: 'market_area',
  probability: 'probability',
  surplus: 'surplus',
  energy_source: 'energy_source',
  price_work: 'price_work',
  price_base: 'price_base',
  balancing_resolution: 'balancing_resolution',
};

export async function getMeteringPointsList(
  contract_portfolio_id?: string,
  portfolio_id?: string,
  status?: string,
  load_profile_type?: string,
  changed_after?: string,
  updated_after?: string,
  apiUrl: string = window.api_url
) {
  let url = new URL(apiUrl + '/metering_points/?');
  let params = {
    contract_portfolio_id,
    portfolio_id,
    status,
    load_profile_type,
    changed_after,
    updated_after,
  };
  Object.keys(params).forEach((key) => {
    if (params[key]) {
      url.searchParams.append(key, params[key]);
    }
  });

  const response = await doRequest(url);

  if (!response.ok) {
    const error = await response.json();
    return [[`Failed Request: ${response.status} ${response.statusText} ${error.message} ${url}`]];
  }

  const json: MeteringPointListResponse = await response.json();
  try {
    const headers = Object.keys(METERING_POINT_MAP);
    const displayNames = Object.values(METERING_POINT_MAP);
    const rows = json.metering_points.map((point) => {
      return headers.map((key) => {
        let value = point[key] ?? '';
        if ((key === 'quantity' || key === 'quantity_override') && point.delivery_type === 'production') {
          return value !== '' ? Number(value) * -1 : '';
        }
        return value;
      });
    })
    return [displayNames, ...rows];
  } catch (error: any) {
    return [[`ERROR: ${error.message}`]];
  }
}
